<button class="left1" mat-raised-button (click)="btnClick()" type="button">
    <span class="style">Add Sales Team</span>
</button>

<section class="content-header">
    <div class="row mb-2">
        <div class="col-sm-6">
            <h1>Sales Teams</h1>
        </div>
        <div class="col-sm-6 text-right">
            <!-- Search and Filter Controls -->
            <div class="form-group mb-0 d-flex align-items-center justify-content-end">
                <!-- Month Filter -->
                <label class="mr-2 mb-0">Filter by Month:</label>
                <p-calendar
                    [(ngModel)]="selectedDate"
                    view="month"
                    dateFormat="mm/yy"
                    [readonlyInput]="true"
                    (onSelect)="onDateChange($event)"
                    (onClear)="clearMonthFilter()"
                    [style]="{'height': '37px'}"
                    styleClass="calendar-filter mr-2"
                    [showClear]="true"
                ></p-calendar>

                <!-- Clear buttons - Only show when a month is selected -->
                <button *ngIf="selectedMonth" 
                        class="btn btn-outline-danger mr-2" 
                        type="button"
                        (click)="clearMonthFilter()"
                        title="Clear month filter">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
    </div>
</section>

<!-- ❌ ALERT SECTION REMOVED - Using toast messages instead -->

<!-- Active Filters Display -->
<div *ngIf="hasActiveFilters" class="active-filters p-3 bg-light border-bottom">
    <small class="text-muted mr-2">Active Filters:</small>
    <span *ngIf="selectedMonth" class="badge badge-info mr-2">
        Month: {{formatSelectedMonth(selectedMonth)}} <i class="fas fa-times ml-1" (click)="clearMonthFilter()"></i>
    </span>
</div>

<!-- Rest of your HTML remains the same -->
<!-- Loader - Show only during initial load with no data -->
<div *ngIf="isLoading && output.length === 0 && !isFutureMonth" class="loader">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<!-- Content -->
<section class="content">
    <!-- Show card only when not loading or when we have data -->
    <div class="card" *ngIf="!isLoading || output.length > 0">
        <div class="card-header">
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                    <i class="fas fa-minus"></i>
                </button>
                <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
        <div class="card-body p-0">
            <table class="table table-striped projects">
                <thead>
                    <tr>
                        <th style="width: 20%">Team Name</th>
                        <th style="width: 20%">Manager Name</th>
                        <th style="width: 20%">Team Size (Including Manager)</th>
                        <th style="width: 15%">Month</th>
                        <th style="width: 25%">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Show data rows when available -->
                    <tr *ngFor="let c of output">
                        <td>
                            <a>{{ c.team_name }}</a>
                        </td>
                        <td>{{ c.brand_manager_name }}</td>
                        <td>{{ c.team_mates.length }}</td>
                        <td>{{ c.month_year }}</td>
                        <td class="project-actions text-right">
                            <a class="btn btn-primary btn-sm" (click)="Details(); getValue(c._id)" style="cursor: pointer;">
                                <i class="fas fa-folder"></i> View
                            </a>
                            <a class="btn btn-info btn-sm left" (click)="EditDetails(); getValue(c._id)" style="cursor: pointer;">
                                <i class="fas fa-pencil-alt"></i> Edit
                            </a>
                            <a class="btn btn-danger btn-sm left" data-toggle="modal" data-target="#modal-sm" 
                               (click)="SetDepartment(c._id, c.team_name)" style="cursor: pointer;">
                                <i class="fas fa-trash"></i> Delete
                            </a>
                        </td>
                    </tr>
                    
                    <!-- Show "No data" message when no results -->
                    <tr *ngIf="output.length === 0 && !isLoading">
                        <td colspan="5" class="text-center py-5">
                            <div *ngIf="hasActiveFilters; else noData">
                                <i class="fas fa-search fa-3x text-muted mb-3"></i>
                                <h5 class="text-muted">No teams found</h5>
                                <p class="text-muted" *ngIf="isFutureMonth; else noFilteredData">
                                    No data available for {{formatSelectedMonth(selectedMonth)}}
                                </p>
                                <ng-template #noFilteredData>
                                    <p class="text-muted">No teams match your current filters</p>
                                </ng-template>
                                <button class="btn btn-primary mt-2" type="button" (click)="clearAllFilters()">
                                    Clear all filters
                                </button>
                            </div>
                            <ng-template #noData>
                                <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                                <h5 class="text-muted">No teams available</h5>
                                <p class="text-muted">There are no sales teams created yet.</p>
                                <button class="btn btn-primary mt-2" type="button" (click)="btnClick()">
                                    <i class="fas fa-plus"></i> Create First Team
                                </button>
                            </ng-template>
                        </td>
                    </tr>
                    
                    <!-- Show loading for table rows during pagination -->
                    <tr *ngIf="isLoading && output.length > 0">
                        <td colspan="5" class="text-center py-3">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span class="ml-2">Loading more data...</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<!-- Delete Confirmation Modal -->
<div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body">
                <p>Are you sure to delete "{{ ListName }}"?</p>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="DeleteList()">Yes</button>
            </div>
        </div>
    </div>
</div>

<!-- Pagination -->
<div *ngIf="!isLoading && output.length > 0 && !isPaginationLoading && !isFutureMonth" class="d-flex justify-content-between align-items-center p-3">
    <div>
        Page {{ currentPage + 1 }}
        <span *ngIf="hasActiveFilters" class="text-muted ml-2">
            (Filtered results)
        </span>
    </div>
    <ul class="pagination">
        <li class="paginate_button page-item previous" [class.disabled]="currentPage === 0">
            <a (click)="clicks_previous()" class="page-link" [class.disabled]="currentPage === 0" style="cursor: pointer;">
                Previous
            </a>
        </li>
        <li class="paginate_button page-item">
            <a class="page-link">{{ currentPage + 1 }}</a>
        </li>
        <li class="paginate_button page-item next" [class.disabled]="!hasNextPage">
            <a (click)="clicks_next()" class="page-link" [class.disabled]="!hasNextPage" style="cursor: pointer;">
                Next
            </a>
        </li>
    </ul>
</div>

<!-- Pagination Loader -->
<div *ngIf="isPaginationLoading" class="text-center p-2">
    <div class="spinner-border spinner-border-sm" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>